import _ from "lodash";
import React from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import { addRelatedConcept } from "IBPlanner/modules/IBPlannerModule";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";

import classes from "./RelatedConcepts.scss";
import RelatedConceptTable from "./RelatedConceptsTable";
import { getRelatedConceptsGroupedValueOptions } from "UnitPlans/modules/UnitPlanModule";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  ELEMENT_TYPE_PYP_RELATED_CONCEPT,
  ELEMENT_TYPE_UBD_RELATED_CONCEPT,
} from "Constants/stringConstants";

const PROGRAM_TYPE_AND_ELEMENT_SET_TYPE_MAPPING = {
  [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_RELATED_CONCEPT,
  [CURRICULUM_TYPE_UBD]: ELEMENT_TYPE_UBD_RELATED_CONCEPT,
};

class RelatedConcepts extends UIBaseComponent {
  constructor(props) {
    super(props);

    if (props.customRef) {
      props.customRef(this);
    }
  }

  shouldShowViewEmpty = () => {
    return false;
  };

  onAddClick = async ({
    groupedOptions,
    currentGroupedOptions,
    groupedValue,
    orgRelatedConceptSets,
  }) => {
    const {
      addRelatedConcept,
      subjects,
      concepts,
      relatedConcepts,
      plannerElementSet,
      groupedValue: oldGroupedValue,
      plannerElementNodeSetId,
    } = this.props;

    const mergedGroupedValue = {
      ...(oldGroupedValue || {}),
      ...(groupedValue || {}),
    };

    const formattedGroupedValue = _.mapValues(mergedGroupedValue, value =>
      _.map(value, "value")
    );

    const newAddedOptions = _.reduce(
      currentGroupedOptions,
      (result, options, key) => {
        const newOptions = _.differenceBy(
          options,
          groupedOptions[key],
          "value"
        );
        const [elementType, elementId] = [...key.split(":")];
        _.map(newOptions, opt => {
          result.push({
            label: opt.label,
            elementId,
            elementType,
          });
        });
        return result;
      },
      []
    );

    let newRelatedConcept = [];
    if (newAddedOptions.length > 0) {
      newRelatedConcept = await addRelatedConcept({
        relatedConcepts: newAddedOptions,
        subjects,
        concepts,
        plannerElementSetId: plannerElementSet.id,
        plannerElementNodeSetId,
      });
      _.forEach(formattedGroupedValue, (value, key) => {
        const [elementType, elementId] = [...key.split(":")];
        const newGroupedOptions = _.filter(
          newRelatedConcept,
          set => set.elementId == elementId && set.elementType == elementType
        );
        _.map(newGroupedOptions, opt => {
          const valIndex = _.indexOf(value, opt.label);
          value[valIndex] = opt.id;
        });
      });
    }
    const mergedValue = _.reduce(
      formattedGroupedValue,
      (result, value) => {
        result = [...result, ...value];
        return result;
      },
      []
    );

    const outPutNodes = _.uniqBy(
      [
        ...(newRelatedConcept || []),
        ...(orgRelatedConceptSets || []),
        ...(relatedConcepts || []),
      ],
      "id"
    );

    this.updateValue(mergedValue, {
      nodes: _.map(outPutNodes, item => {
        return {
          node: item,
        };
      }),
    });
  };

  renderRelatedConceptDropDown = () => {
    const {
      groupedRelatedConcepts,
      fieldLockedObject,
      readOnly,
      testId,
      subjects,
      concepts,
      selectedRelatedConcepts,
      value,
      options,
      mode,
      isCourseOverview,
      plannerElementNodeSetId,
    } = this.props;

    const { lockedDynamicFields } = fieldLockedObject;

    return (
      <div className={classes.container}>
        <div className={classes.list}>
          <RelatedConceptTable
            readOnly={readOnly}
            groupedRelatedConcepts={groupedRelatedConcepts}
            lockedDynamicFields={lockedDynamicFields}
            mode={mode}
            onAddClick={this.onAddClick}
            testId={`${testId}-relatedConcepts`}
            subjects={subjects}
            concepts={concepts}
            value={value}
            groupedOptionsFields={_.get(options, "groupedOptionsFields", [])}
            selectedRelatedConcepts={selectedRelatedConcepts}
            isCourseOverview={isCourseOverview}
            plannerElementNodeSetId={plannerElementNodeSetId}
          />
        </div>
      </div>
    );
  };
  renderEdit = () => this.renderRelatedConceptDropDown();
  renderView = () => this.renderRelatedConceptDropDown();
}

const mapActionCreators = {
  addRelatedConcept,
};

const mapStateToProps = (state, ownProps) => {
  const { resolvedValue, options, value } = ownProps;

  const {
    groupedRelatedConcepts,
    groupedValue,
    groupedOptions,
  } = memoizedGetGroupedValueOptions({
    nodes: _.get(resolvedValue, "relatedConcepts", []),
    subjects: _.get(options, "subjects", []),
    value,
    concepts: _.get(options, "concepts", []),
    groupedOptionsFields: _.get(options, "groupedOptionsFields", []),
  });

  const currentCurriculumProgram = state.platform.currentCurriculumProgram;
  const currentCurriculumProgramType = currentCurriculumProgram.type;
  const plannerElementSetType =
    PROGRAM_TYPE_AND_ELEMENT_SET_TYPE_MAPPING[currentCurriculumProgramType];

  const currentPlannerElementSet =
    state.platform.currentPlannerElementSets[plannerElementSetType];

  const plannerElementNodeSetId = _.get(options, "plannerElementNodeSetId");

  return {
    isData: true,
    isLoading: false,
    organizationId: state.login.userInfo.org_id,
    subjects: options.subjects,
    concepts: options.concepts,
    groupedRelatedConcepts,
    groupedOptions,
    groupedValue,
    plannerElementSet: currentPlannerElementSet,
    selectedRelatedConcepts: _.get(resolvedValue, "relatedConcepts", []),
    relatedConcepts: _.get(resolvedValue, "relatedConcepts", []),
    plannerElementNodeSetId,
  };
};

const memoizedGetGroupedValueOptions = _.memoize(
  getRelatedConceptsGroupedValueOptions,
  params => JSON.stringify(params)
);

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: "unitPlan" })
)(RelatedConcepts);
